module.exports = __webpack_public_path__ + "static/media/green-check-icon.f7870962.svg";